<template>
    <div :style="{'max-width': '1600px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <div style="text-align: left;">
            <b-card>
                <h4>PRODUCT CATALOG</h4>

                <div
                  v-if="isMobile"
                  class="d-flex justify-content-between align-items-center mb-2 py-2"
                >
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="filtersVisible = !filtersVisible"
                  >
                    <b-icon-funnel-fill class="mr-1" />
                    {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
                  </b-button>
                </div>

                <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;">
                    <b-alert variant="success" show style="display: inline-block;">
                        <div>
                            FETCH BY CATEGORY
                        </div>
                        <b-form-select :options="packet.categories" v-model="category_id" @change="fetch_category" style="width: 100%; max-width: 250px;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-alert>
                    <b-alert variant="success" show style="display: inline-block;">
                <div>
                    FETCH BY SUBCATEGORY
                </div>
                <b-form-select 
                    :options="subcategoryOptions" 
                    v-model="subcategory_id" 
                    @change="fetchSubcategory"
                    style="width: 100%; max-width: 250px;"
                    :disabled="!category_id"
                >
                    <template #first>
                        <b-form-select-option :value="null">ALL</b-form-select-option>
                    </template>
                </b-form-select>
            </b-alert>

                    <b-alert variant="success" show style="display: inline-block;">
                        <div>
                            FETCH BY VENDOR
                        </div>
                        <b-form-select :options="packet.vendors" v-model="vendor_id" @change="fetch_vendor" style="width: 100%; max-width: 250px;">
                            <template #first>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-alert>

                    <b-alert variant="success" show style="display: inline-block; width: 100%; max-width: 480px;">
                        <div>
                            SEARCH BY PRODUCT NAME OR SKU
                        </div>
                        <div style="display: inline-block; width: 100%; max-width: 350px">
                            <b-input v-model="product_query"></b-input>
                        </div>
                        <div style="display: inline-block;">
                            <b-button @click="fetch_product_name_sku">SUBMIT</b-button>
                        </div>
                    </b-alert>

                        <!-- Stock Status Filter -->
                    <b-alert variant="success" show style="display: inline-block;">
                        <div>
                            STOCK STATUS
                        </div>
                        <b-form-select
                            :options="stockStatusOptions"
                            v-model="stock_status"
                            @change="applyFilters"
                            style="width: 100%; max-width: 250px;"
                        >
                            <template #first>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-alert>

                    <!-- Item Type Filter -->
                    <b-alert variant="success" show style="display: inline-block;">
                        <div>
                            ITEM TYPE
                        </div>
                        <b-form-select
                            :options="itemTypeOptions"
                            v-model="item_type"
                            @change="applyFilters"
                            style="width: 100%; max-width: 250px;"
                        >
                            <template #first>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-alert>

                    <!-- Clear Filters Button -->
                    <b-alert variant="warning" show style="display: inline-block;">
                        <div>
                            CLEAR FILTERS
                        </div>
                        <b-button
                            variant="warning"
                            @click="clearFilters"
                            style="width: 100%; max-width: 150px;"
                        >
                            Clear All
                        </b-button>
                    </b-alert>

                    <!-- <template v-if="isAdmin">
                        <b-alert variant="info" show style="display: inline-block; margin-right: 10px;">
                            <div>
                                FETCH IMAGES & SLUGS
                            </div>
                            <b-button
                                variant="primary"
                                @click="fetchImagesAndSlugs"
                                :disabled="fetchingData"
                                style="width: 100%; max-width: 200px;"
                            >
                                <b-spinner small v-if="fetchingData"></b-spinner>
                                {{ fetchingData ? 'Fetching...' : 'Fetch from API' }}
                            </b-button>
                        </b-alert>

                        <b-alert variant="info" show style="display: inline-block; margin-right: 10px;">
                            <div>
                                FIND MATCHING SKUs
                            </div>
                            <b-button
                                variant="info"
                                @click="findMatchingSKUs"
                                :disabled="fetchingData"
                                style="width: 100%; max-width: 200px;"
                            >
                                <b-spinner small v-if="fetchingData"></b-spinner>
                                {{ fetchingData ? 'Testing...' : 'Test SKU Matching' }}
                            </b-button>
                        </b-alert>
                    </template> -->
                </b-collapse>

            </b-card>
        </div>

        <div v-if="items_being_loaded == true">
            <loading :active="items_being_loaded"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>

        <div v-else>
            <!-- Filter Summary -->
            <b-card v-if="hasActiveFilters" style="margin-top: 10px; background-color: #f8f9fa;">
                <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 10px;">
                    <strong>Active Filters:</strong>
                    <b-badge v-if="stock_status" variant="info">
                        Stock: {{ getStockStatusLabel(stock_status) }}
                        <b-icon-x @click="removeFilter('stock_status')" style="cursor: pointer; margin-left: 5px;"></b-icon-x>
                    </b-badge>
                    <b-badge v-if="item_type" variant="info">
                        Type: {{ getItemTypeLabel(item_type) }}
                        <b-icon-x @click="removeFilter('item_type')" style="cursor: pointer; margin-left: 5px;"></b-icon-x>
                    </b-badge>
                    <b-badge v-if="category_id" variant="info">
                        Category: {{ getCategoryLabel(category_id) }}
                        <b-icon-x @click="removeFilter('category_id')" style="cursor: pointer; margin-left: 5px;"></b-icon-x>
                    </b-badge>
                    <b-badge v-if="subcategory_id" variant="info">
                        Subcategory: {{ getSubcategoryLabel(subcategory_id) }}
                        <b-icon-x @click="removeFilter('subcategory_id')" style="cursor: pointer; margin-left: 5px;"></b-icon-x>
                    </b-badge>
                    <b-badge v-if="vendor_id" variant="info">
                        Vendor: {{ getVendorLabel(vendor_id) }}
                        <b-icon-x @click="removeFilter('vendor_id')" style="cursor: pointer; margin-left: 5px;"></b-icon-x>
                    </b-badge>
                    <b-badge v-if="product_query" variant="info">
                        Search: {{ product_query }}
                        <b-icon-x @click="removeFilter('product_query')" style="cursor: pointer; margin-left: 5px;"></b-icon-x>
                    </b-badge>
                </div>
            </b-card>

            <div v-if="filteredItems.length > 0">
                <b-card style="margin-top: 10px;">
                    <div>
                        <b-card-group deck>
                            <b-card
                                style="max-width: 19.3rem; min-width: 19.3rem; margin: 5px; cursor: pointer;"
                                v-for="item, idx in filteredItems"
                                v-bind:key="idx"
                                @click="goToProductPage(item)"
                            >
                                <!-- Product Image -->
                                <div v-if="item.image_url" style="text-align: center; margin-bottom: 10px; height: 150px; display: flex; align-items: center; justify-content: center;">
                                    <img
                                        :src="item.image_url"
                                        :alt="item.product_name"
                                        style="max-width: 100%; max-height: 150px; object-fit: contain;"
                                        @error="handleImageError"
                                        class="product-image"
                                    />
                                </div>

                                <!-- Fallback when no image -->
                                <div v-else style="text-align: center; margin-bottom: 10px; height: 150px; display: flex; align-items: center; justify-content: center; background: #f8f9fa; border-radius: 5px;">
                                    <div style="color: #6c757d; font-size: 12px;">
                                        No Image Available
                                    </div>
                                </div>

                                <!-- Product Details -->
                                <b-card-title style="font-size: 15px; min-height: 40px;">
                                    <a
                                        :href="getProductUrl(item)"
                                        @click.stop.prevent="goToProductPage(item)"
                                        style="color: inherit; text-decoration: none;"
                                        class="product-link"
                                    >
                                        {{item.product_name}}
                                    </a>
                                </b-card-title>

                                <b-card-sub-title style="font-size: 13px;">
                                    <a
                                        :href="getProductUrl(item)"
                                        @click.stop.prevent="goToProductPage(item)"
                                        style="color: inherit; text-decoration: none;"
                                    >
                                        {{item.product_sku}}
                                    </a>
                                </b-card-sub-title>

                                <b-card-text>
                                    <b-badge variant="primary">{{item.category}}</b-badge>
                                    <b-badge variant="secondary" v-if="item.subcategory">{{item.subcategory}}</b-badge>
                                    <b-badge variant="success">{{item.vendor}}</b-badge>
                                    <!-- Item Type Badge -->
                                    <b-badge :variant="getItemTypeBadgeVariant(item)">
                                        {{ getItemType(item) }}
                                    </b-badge>
                                </b-card-text>

                                <b-card-text v-if="item.slug" style="font-size: 12px; color: #666;">
                                    <a
                                        :href="getProductUrl(item)"
                                        @click.stop.prevent="goToProductPage(item)"
                                        style="color: #007bff; text-decoration: none;"
                                    >
                                        View Product Page →
                                    </a>
                                </b-card-text>

                                <b-card-text>
                                    <div style="font-size: 13px; color: #2d3e45; background: whitesmoke; display: inline; margin-top: 5px; padding: 3px; font-weight: bold;">
                                        ${{ parseFloat(item.selling_price).toFixed(2) }}
                                    </div>
                                </b-card-text>

                                <!-- Availability and Actions -->
                                <div style="margin-top: 15px; text-align: left;">
                                    <span v-if="item.availability == 0">
                                        <b-button variant="outline-danger" size="sm" :disabled="true" style="font-size: 11px;">{{item.availability}} Available</b-button>
                                    </span>
                                    <span v-else>
                                        <b-button variant="outline-success" size="sm" style="font-size: 11px;">{{item.availability}} Available</b-button>
                                    </span>

                                    <b-button variant="outline-primary" size="sm" @click.stop="viewComponents(idx)" v-if="item.children.length > 0">View Components</b-button>
                                </div>
                            </b-card>
                        </b-card-group>
                    </div>

                    <!-- Results Count -->
                    <div style="margin-top: 15px; text-align: center;">
                        <b-badge variant="secondary">
                            Showing {{ filteredItems.length }} of {{ allItems.length }} products
                        </b-badge>
                    </div>

                    <b-modal id="modal-availability" scrollable title="" size="md" hide-footer>
                        <Availability :viewdata="{availability_data:availability_data, product_id: q_product_id, product_sku: q_product_sku}" :locationsdict="locationsdict" :sublocationsdict="sublocationsdict" />
                    </b-modal>

                    <b-modal id="modal-children" scrollable title="Child Products" size="md" hide-footer>
                        <Children :viewdata="components_data" />
                    </b-modal>
                </b-card>
            </div>
            <div v-else class="mt-2">
                <b-alert variant="warning" show>NO PRODUCTS FOUND MATCHING YOUR FILTERS</b-alert>
            </div>
        </div>
    </div>
</template>

<script>
    import global_vars from '@/utilities/global_vars'
    import moment from 'moment'
    import Backer from '@/components/globals/Backer'
    import Availability from "@/components/importables/Availability"
    import Children from "@/components/importables/Children"
    import Requestor from '@/utilities/Requestor'
    import { BIconFunnelFill } from "bootstrap-vue";

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "ProductCatalog",
        props: ["showbacker"],
        components: {Backer, Loading, Availability, Children},
        data: function(){
            return {
                userDetails: {properties: {}},
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                subcategory_id: null,
                 subcategories: [],
                tr_item_statuses: global_vars.TRANSFER_STATUSES,
                tr_item_statuses_colors: global_vars.TRANSFER_STATUSES_COLORS_DICT,
                tr_item_statuses_dict: global_vars.TRANSFER_STATUSES_DICT,
                items: [],
                allItems: [], // Store all items from API
                items_being_loaded: false,
                sort_asc: true,
                actions_disabled: false,
                category_id: null,
                vendor_id: null,
                q_product_id: null,
                q_product_sku: null,
                availability_data: [],
                stock_status: null, // 'in_stock', 'out_of_stock', null for all
                item_type: null,
                components_data: [],
                  stockStatusOptions: [
                    { value: 'in_stock', text: 'In Stock' },
                    { value: 'out_of_stock', text: 'Out of Stock' }
                ],
                itemTypeOptions: [
                    { value: 'single', text: 'Single Items' },
                    { value: 'group', text: 'Group Items' }
                ],
                 fetchingData: false,
                product_query: null,
                packet: {},
                filtersVisible: false,
                isMobile: false,
            }
        },
         computed: {
            subcategoryOptions: function() {
        if (!this.category_id) {
            return [{ value: null, text: 'Select Category First' }];
        }
        
        // Filter subcategories by selected category
        const filteredSubcategories = this.subcategories.filter(
            subcat => subcat.category_id == this.category_id
        );
        
        return [
            { value: null, text: 'ALL' },
            ...filteredSubcategories.map(subcat => ({
                value: subcat.id,  // This is correct
                text: subcat.subcategory  // Change from 'name' to 'subcategory'
            }))
        ];
    },
            isAdmin: function() {
                // Check if user is admin based on your user structure
                // Adjust this logic based on how you store user roles
                if (this.packet.userDetails && this.packet.userDetails.properties) {
                    // Option 1: Check by role property
                    return this.packet.userDetails.userrole === 'admin' ||
                           this.packet.userDetails.properties.is_admin === true;

                    // Option 2: Check by permissions
                    // return this.packet.userDetails.properties.permissions &&
                    //        this.packet.userDetails.properties.permissions.includes('admin');

                    // Option 3: Check by user type
                    // return this.packet.userDetails.properties.user_type === 'admin';
                }
                return false;
            },
               hasActiveFilters: function() {
                return this.stock_status !== null ||
                       this.item_type !== null ||
                       this.category_id !== null ||
                       this.subcategory_id !== null ||
                       this.vendor_id !== null ||
                       (this.product_query && this.product_query.length > 0);
            },
            filteredItems: function() {
                let filtered = [...this.allItems];

                // Apply stock status filter
                if (this.stock_status === 'in_stock') {
                    filtered = filtered.filter(item => item.availability > 0);
                } else if (this.stock_status === 'out_of_stock') {
                    filtered = filtered.filter(item => item.availability === 0);
                }

                // Apply item type filter
                if (this.item_type === 'single') {
                    filtered = filtered.filter(item => item.children.length === 0);
                } else if (this.item_type === 'group') {
                    filtered = filtered.filter(item => item.children.length > 0);
                }

                return filtered;
            },
        },
        methods: {
         fetchSubcategories: function() {
    let that = this;
    
    let path = "/api/product/get_subcategories/";
    let data = {};
    
    // Send category_id if it's selected
    if (this.category_id) {
        data.category_id = this.category_id;
    }
    
     let s = function(response) {
        console.log("Raw API response:", response);
        console.log("Response data:", response.data);
        
        if (response.data && !response.data.error) {
            that.subcategories = response.data.result || [];
            console.log("Subcategories stored:", that.subcategories);
            console.log("Category ID:", that.category_id);
            
            // Log what the computed property produces
            console.log("Subcategory options computed:", that.subcategoryOptions);
        } else {
            that.$bvToast.toast(
                response.data.error || "Error loading subcategories",
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        }
    };
    
    let f = function(error) {
        console.error("Error loading subcategories:", error);
        that.$bvToast.toast(
            "Error loading subcategories. Please check console for details.",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
        );
    };
    
    // Make sure you're using POST method
    Requestor.postSyncP(path, data, this, s, f);
},
         fetchSubcategory: function() {
            let that = this;
            let data = {};
            
            // Include category filter if selected
            if (this.category_id) {
                data.category_id = this.category_id;
            }
            
            // Include subcategory filter
            if (this.subcategory_id) {
                data.subcategory_id = this.subcategory_id;
            }
            
            // Include vendor filter if selected
            if (this.vendor_id != null) {
                data.vendor_id = this.vendor_id;
            }
            
            let path = "/api/product/get_products_for_catalog/";
            let s = function(response) {
                if (response.data.result) {
                    that.allItems = response.data.result;
                    that.items = [...that.allItems];
                } else {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                that.items_being_loaded = false;
                that.actions_disabled = false;
            };
            
            let f = function(error) {
                console.log(error);
                that.$bvToast.toast(
                    "Error loading products.",
                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                );
                that.items_being_loaded = false;
                that.actions_disabled = false;
            };
            
            this.items_being_loaded = true;
            this.actions_disabled = true;
            this.product_query = null;
            Requestor.postSyncP(path, data, this, s, f);
        },
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
              applyFilters: function() {
                // This will automatically update filteredItems through computed property
                // No need to call API again since we're filtering client-side
                console.log("Filters applied:", {
                    stock_status: this.stock_status,
                    item_type: this.item_type
                });
            },

            clearFilters: function() {
                this.stock_status = null;
                this.item_type = null;
                this.category_id = null;
                this.subcategory_id = null;
                this.vendor_id = null;
                this.product_query = null;
                // Reset to show all items
                this.items = [...this.allItems];
            },

            removeFilter: function(filterType) {
                if (filterType === 'stock_status') {
                    this.stock_status = null;
                } else if (filterType === 'item_type') {
                    this.item_type = null;
                } else if (filterType === 'category_id') {
                    this.category_id = null;
                    this.subcategory_id = null;
                 } else if (filterType === 'subcategory_id') {
                this.subcategory_id = null;
                this.fetchSubcategory(); 
                    this.fetchProducts(); // Refetch from API
                } else if (filterType === 'vendor_id') {
                    this.vendor_id = null;
                    this.fetchProducts(); // Refetch from API
                } else if (filterType === 'product_query') {
                    this.product_query = null;
                    this.fetchProducts(); // Refetch from API
                }
            },
            getSubcategoryLabel: function(subcategoryId) {
    const subcategory = this.subcategories.find(sub => sub.id === subcategoryId);
    return subcategory ? subcategory.subcategory : subcategoryId;  // Change 'name' to 'subcategory'
},
   getStockStatusLabel: function(status) {
                const option = this.stockStatusOptions.find(opt => opt.value === status);
                return option ? option.text : status;
            },

            getItemTypeLabel: function(type) {
                const option = this.itemTypeOptions.find(opt => opt.value === type);
                return option ? option.text : type;
            },

            getCategoryLabel: function(categoryId) {
                const category = this.packet.categories.find(cat => cat.value === categoryId);
                return category ? category.text : categoryId;
            },

            getVendorLabel: function(vendorId) {
                const vendor = this.packet.vendors.find(vend => vend.value === vendorId);
                return vendor ? vendor.text : vendorId;
            },

            getItemType: function(item) {
                return item.children.length > 0 ? 'Group Item' : 'Single Item';
            },

            getItemTypeBadgeVariant: function(item) {
                return item.children.length > 0 ? 'warning' : 'info';
            },

              getProductUrl(item) {
        if (item.slug) {
            return `https://fmapi.myfurnituremecca.com/product/${item.slug}`;
        }
        // Fallback to SKU-based URL or return null
        return `https://fmapi.myfurnituremecca.com/product/${item.product_sku}`;
    },
       goToProductPage(item) {
        const url = this.getProductUrl(item);
        if (url) {
            // Open in new tab
            window.open(url, '_blank');
        } else {
            this.$bvToast.toast(
                'Product URL not available',
                {title: "Error", autoHideDelay: 3000, variant:"warning"}
            );
        }
    },
     handleImageError(event) {
        // Hide broken images and show fallback
        const parent = event.target.parentElement;
        event.target.style.display = 'none';

        // Create fallback message if it doesn't exist
        if (!parent.querySelector('.image-fallback')) {
            const fallback = document.createElement('div');
            fallback.className = 'image-fallback';
            fallback.style.cssText = 'color: #6c757d; font-size: 12px; width: 100%; text-align: center;';
            fallback.textContent = 'Image Not Available';
            parent.appendChild(fallback);
        }
    },
             fetchImagesAndSlugs: function() {
            let that = this;

            this.$bvModal.msgBoxConfirm('This will fetch image URLs and slugs from API for all products. Continue?', {
                title: 'Confirm Fetch',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(confirmed => {
                if (confirmed) {
                    that.executeFetch();
                }
            });
        },
        executeFetch: function() {
    let that = this;
    this.fetchingData = true;

    let path = "/api/product/fetch_images_and_slugs/";
    let data = {};

    let s = function(response) {
        that.fetchingData = false;

        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 8000, variant:"danger"}
            );
        } else {
            const result = response.data.result;
            const total = result.updated + result.failed;

            let message = `Processed ${total} products: ${result.updated} updated, ${result.failed} failed.`;

            if (result.details && result.details.length > 0) {
                // Show first few results
                const successCount = result.details.filter(d => d.status === 'updated').length;
                const failCount = result.details.filter(d => d.status === 'failed').length;
                message += ` Sample: ${successCount} success, ${failCount} failed.`;

                console.log("Fetch details:", result.details);
            }

            that.$bvToast.toast(
                message,
                {title: "Fetch Complete", autoHideDelay: 8000, variant:"success"}
            );

            // Refresh the product list to show updated data
            that.fetchProducts();
        }
    };

    let f = function(error) {
        that.fetchingData = false;
        console.error("Fetch error:", error);
        that.$bvToast.toast(
            "Error fetching data from API. The process might be taking too long. Check server logs.",
            {title: "Error", autoHideDelay: 8000, variant:"danger"}
        );
    };

    // Add timeout for long-running request
    Requestor.postSyncP(path, data, this, s, f);
},
findMatchingSKUs: function() {
    let that = this;

    this.$bvModal.msgBoxConfirm('This will test a sample of SKUs to find which ones exist in the Furniture Mecca API. Continue?', {
        title: 'Find Matching SKUs',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
    })
    .then(confirmed => {
        if (confirmed) {
            that.executeFindMatchingSKUs();
        }
    });
},

executeFindMatchingSKUs: function() {
    let that = this;
    this.fetchingData = true;

    let path = "/api/product/find_matching_skus/";
    let data = {};

    let s = function(response) {
        that.fetchingData = false;

        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 5000, variant:"danger"}
            );
        } else {
            const result = response.data.result;
            const foundCount = result.found.length;
            const notFoundCount = result.not_found.length;
            const total = result.total_tested;

            let message = `Tested ${total} SKUs: ${foundCount} found, ${notFoundCount} not found.`;

            if (foundCount > 0) {
                message += ` Found SKUs: ${result.found.map(item => item.sku).slice(0, 5).join(', ')}${foundCount > 5 ? '...' : ''}`;
            }

            that.$bvToast.toast(
                message,
                {title: "Matching SKUs Found", autoHideDelay: 8000, variant:"success"}
            );

            console.log("Matching SKU details:", result);
        }
    };

    let f = function(error) {
        that.fetchingData = false;
        console.error("Find matching SKUs error:", error);
        that.$bvToast.toast(
            "Error finding matching SKUs. Please try again.",
            {title: "Error", autoHideDelay: 5000, variant:"danger"}
        );
    };

    Requestor.postSyncP(path, data, this, s, f);
},
testSingleSKU: function() {
    let testSKU = "1610-65L-75-65R"; // Use a known SKU
    let path = "/api/product/test_single_sku/";
    let data = {sku: testSKU};

    let s = function(response) {
        console.log("Test API response:", response.data);
        alert("Check console for test results");
    };

    let f = function(error) {
        console.error("Test API error:", error);
    };

    Requestor.postSyncP(path, data, this, s, f);
},
  handleImageError(event) {
            // Hide broken images
            event.target.style.display = 'none';
        },
            logger: function(e){
                console.log(this.selected_sublocations)
                console.log(this.vendor_id)
            },
            fetch_prereqs: function(){
                let that = this;

                let prereqs = [
                    {
                        path:  "/api/user/get_tools_packet/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){

                                that.categories = response.data.result.categories;
                                that.vendors = response.data.result.vendors;

                                that.locations = response.data.result.locations.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locations.splice(0, 0, {value: null,  text: "All"});
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.sublocations = response.data.result.sublocations.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error,
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
           fetch_category: function(){
                let that = this;
                let data = {
                    category_id: this.category_id,
                }
                this.subcategory_id = null;
                if (this.vendor_id != null){
                    data.vendor_id = this.vendor_id;
                }

                let path = "/api/product/get_products_for_catalog/"
                let s = function(response){
                    if (response.data.result){
                        that.allItems = response.data.result;
                        that.items = [...that.allItems];
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading products.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                this.items_being_loaded = true
                this.actions_disabled = true
                this.product_query = null;
                Requestor.postSyncP(path, data, this, s, f);
            },

            fetch_vendor: function(){
                let that = this;
                let data = {
                    vendor_id: this.vendor_id,
                }
                if (this.category_id != null){
                    data.category_id = this.category_id;
                }

                let path = "/api/product/get_products_for_catalog/"
                let s = function(response){
                    if (response.data.result){
                        that.allItems = response.data.result;
                        that.items = [...that.allItems];
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading products.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                this.items_being_loaded = true
                this.actions_disabled = true
                this.product_query = null;
                Requestor.postSyncP(path, data, this, s, f);
            },

            fetch_product_name_sku: function(){
                let that = this;
                if (!this.product_query || this.product_query.length < 2){
                    this.$vex.dialog.alert({message: "Please specify valid product name or sku."});
                    return
                }
                let data = {
                    product_query: this.product_query,
                }

                let path = "/api/product/get_products_for_catalog/"
                let s = function(response){
                    if (response.data.result){
                        that.allItems = response.data.result;
                        that.items = [...that.allItems];
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading products.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                this.items_being_loaded = true
                this.actions_disabled = true
                this.category_id = null;
                this.vendor_id = null;
                Requestor.postSyncP(path, data, this, s, f);
            },

            fetchProducts: function(e){
                if (e){
                    e.preventDefault()
                }

                let that = this;
                let data = {
                    category_id: this.category_id,
                    product_query: (this.product_query || "").toLowerCase().replace("'", "").replace(";", ""),
                    limit: 600
                }

                let path = "/api/product/get_products_for_catalog/"
                let s = function(response){
                    if (response.data.result){
                        that.allItems = response.data.result;
                        that.items = [...that.allItems];
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading products.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                    that.actions_disabled = false
                }

                this.items_being_loaded = true
                this.actions_disabled = true
                Requestor.postSyncP(path, data, this, s, f);
            },

            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            },
            checkItemAvailability: function(idx){
                let path = "/api/inventory/get_tr_item_availability/";
                let item = this.items[idx];
                let data = {product_id: item.product_id, product_sku: item.product_sku};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.availability_data = response.data.result;
                        that.q_product_id = item.product_id;
                        that.q_product_sku = item.product_sku;
                        that.$bvModal.show("modal-availability");
                    }
                    that.is_action_disabled = false
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "An error occurred trying to fetch product availability. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.is_action_disabled = false
                }
                this.is_action_disabled = true;
                Requestor.getAsync(path, data, s, f);

            },
            viewComponents: function(idx){
                let children = this.items[idx].children;
                this.components_data = children;
                this.$bvModal.show("modal-children");
            }



        },
        mounted: function() {
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.handleResize);
        },
        created: function(){
            // let userDetails = localStorage.userDetails;
            // if (userDetails){
            //     this.userDetails = JSON.parse(userDetails);
            //     this.fetch_prereqs();

            // }

            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            // this.vendors = this.packet.vendors;
            // this.categories = this.packet.categories;
            //this.fetch_prereqs()
            this.fetchSubcategories();
        }
    }
</script>

<style scoped>
    td {
        padding: 3px;
        font-size: 14px;
    }

    select {
        font-size: 14px;
    }
      .product-image {
        transition: transform 0.2s ease-in-out;
    }

    .product-image:hover {
        transform: scale(1.05);
    }

    .product-link:hover {
        color: #007bff !important;
        text-decoration: underline !important;
    }

    .card:hover {
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.2s ease-in-out;
    }

    td {
        padding: 3px;
        font-size: 14px;
    }

    select {
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Products/ProductCatalog.vue